import type { KeyboardEvent } from "react";

export type KeyboardActivationHandler = (event: KeyboardEvent) => void;

/**
 * Returns a keyboard handler that triggers the provided callback when
 * the user presses Space or Enter. Prevents double activation by calling
 * `preventDefault` on handled keys.
 */
export const handleKeyboardActivation = (
  onActivate: () => void
): KeyboardActivationHandler => {
  return (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onActivate();
    }
  };
};
